var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-dropdown',{attrs:{"right":"","variant":"link","no-caret":"","toggle-class":"action-button","menu-class":"z-index-2000"},scopedSlots:_vm._u([_vm._l((Object.keys(this.$scopedSlots)),function(slotName){return {key:slotName,fn:function(context){return [_vm._t(slotName,null,null,context)]}}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }